<template>

<div class="bg-secondary py-5">

        <inertia-head title="Verify">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 600px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Verify Your Email Address') }}</div>

                        <div class="card-body">
                            <div class="alert alert-success" role="alert" v-if="resent">
                                {{ __('A fresh verification link has been sent to your email address.') }}
                            </div>

                            {{ __('Before proceeding, please check your email for a verification link.') }}
                            {{ __('If you did not receive the email') }},

                            <hr />
                            <inertia-link class="btn btn-outline-primary" :href="route('verification.resend')" method="post">
                                {{ __('click here to request another') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: [
            'resent'
        ],
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                    password: null,
                    remember: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
    }
</script>
